export default "__VITE_ASSET__C1f6o0tF__"